import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { SelectModule } from 'primeng/select';
import { isObservable } from 'rxjs';

@Component({
    selector: 'formly-primeng-field-select',
    imports: [ReactiveFormsModule, SelectModule],
    template: `
        <p-select
            class="w-full"
            appendTo="body"
            [options]="selectOptions"
            [id]="fieldId"
            [formControl]="formControl" optionLabel="label" optionValue="value">
        </p-select>
    `,
})

export class SelectFieldCosmos extends FieldType<FieldTypeConfig> {

    get selectOptions(): any[] {
        const options = this.props.options;
        return isObservable(options) ? [] : (options ?? []);
    }

    get fieldId(): string {
        return Array.isArray(this.key) ? this.key.join('_') : String(this.key);
    }

    ngOnInit() { }
}